// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3zvfD","title":"AfterImages90_title__1QypJ","images":"AfterImages90_images__-ezDT"};